import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import FissaVisita from './FissaVisita';
import { messaggioErrore } from '../../utils/agenda';

// "Sposta" e "Annulla visita" per lo staff (scheda cliente, scheda immobile, agenda, Oggi). Sposta apre "Fissa
// visita" già sullo slot di adesso (POST /visite/{id}/sposta); Annulla chiede il motivo e avvisa cliente e agenzia
// (POST /visite/{id}/annulla: la voce esce dall'agenda, l'immobile torna com'era, cronologia).

export const MOTIVI_ANNULLA = [
  ['cliente_non_puo', 'Il cliente non può'], ['agenzia_disdetto', "L'agenzia ha disdetto"], ['immobile_venduto', 'Immobile venduto'], ['altro', 'Altro'],
];

export const AnnullaVisita = ({ visita, onChiudi, onFatto }) => {
  const [motivo, setMotivo] = useState('');
  const [nota, setNota] = useState('');
  const [attesa, setAttesa] = useState(false);
  useEffect(() => {
    const esc = (e) => { if (e.key === 'Escape') onChiudi(); };
    document.addEventListener('keydown', esc);
    return () => document.removeEventListener('keydown', esc);
  }, [onChiudi]);
  const pronta = motivo && (motivo !== 'altro' || nota.trim());
  const annulla = async () => {
    if (!pronta) return;
    setAttesa(true);
    try {
      const r = await axios.post(`${API}/visite/${visita.id}/annulla`, { motivo, nota: nota.trim() || undefined });
      toast.success(`Visita annullata${r.data.agenzia_avvisata ? ': avvisati il cliente e l\'agenzia' : ': avvisato il cliente'}`);
      onFatto(r.data);
    } catch (e) {
      toast.error(messaggioErrore(e, 'Visita non annullata. Riprovate.'));
      setAttesa(false);
    }
  };
  return createPortal(
    <div className="st st-modale elimina-modale" role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) onChiudi(); }}>
      <div className="scatola" role="dialog" aria-modal="true" aria-labelledby="annulla-titolo" data-testid="annulla-visita">
        <h3 id="annulla-titolo">Annullare la visita{visita.testo ? ` di ${visita.testo}` : ''}?</h3>
        <p>Perché?</p>
        <div className="motivi" role="group" aria-label="Motivo">
          {MOTIVI_ANNULLA.map(([k, t]) => (
            <button type="button" key={k} className={`chip${motivo === k ? ' on' : ''}`} aria-pressed={motivo === k} onClick={() => setMotivo(k)}>{t}</button>
          ))}
        </div>
        {/* la nota va al cliente (storia della casa, Novità, email), come quella di "Fissa visita": prima "Nota (facoltativa)".
            Un nome solo: l'etichetta diceva "Nota per il cliente" e chi legge con la voce sentiva "Nota sull'annullamento" */}
        <label className="parola">Nota per il cliente ({motivo === 'altro' ? 'serve: ' : ''}la legge nell'app e nell'email)
          <input value={nota} onChange={(e) => setNota(e.target.value)} maxLength={500} aria-label="Nota per il cliente" />
        </label>
        <p className="nota">Avvisiamo il cliente (email e push) e l'agenzia (email, se non è lei ad aver disdetto). La visita esce dall'agenda e l'immobile torna com'era: visita richiesta, altrimenti da contattare (venduto: scartato).</p>
        <div className="bottoni">
          <button type="button" className="btn sm" onClick={onChiudi}>Indietro</button>
          <button type="button" className="btn sm rosso" onClick={annulla} disabled={!pronta || attesa}>{attesa ? 'Annullo…' : 'Annulla la visita'}</button>
        </div>
      </div>
    </div>,
    document.querySelector('.mk-staff') || document.body,
  );
};

// I due bottoni, con le loro finestre. visita = {id, data, ora, durata, accompagna_id, immobile_id, testo};
// cliente = {id, nome}
const AzioniVisita = ({ visita, cliente, onFatto, piccoli = false, soloSposta = false }) => {
  const [aperta, setAperta] = useState(null);  // 'sposta' | 'annulla'
  const classe = `btn ${piccoli ? 'xs' : 'sm'}`;
  const fatto = (r) => { setAperta(null); if (onFatto) onFatto(r); };
  if (!visita?.id) return null;
  return (
    <>
      <button type="button" className={classe} onClick={() => setAperta('sposta')}>Sposta</button>
      {!soloSposta && <button type="button" className={`${classe} rosso-vuoto`} onClick={() => setAperta('annulla')}>Annulla</button>}
      {aperta === 'sposta' && (
        <FissaVisita clienteId={cliente?.id || visita.cliente_id} clienteNome={cliente?.nome || visita.cliente_nome || ''} immobileId={visita.immobile_id}
          sposta={visita} onChiudi={() => setAperta(null)} onFatto={fatto} />
      )}
      {aperta === 'annulla' && <AnnullaVisita visita={visita} onChiudi={() => setAperta(null)} onFatto={fatto} />}
    </>
  );
};

export default AzioniVisita;
